/**
 * EarningsDashboard.jsx — earnings/EarningsDashboard.jsx
 *
 * Container that renders either EarningsTab or VolAnalysisTab.
 * Navigation is provided by the parent (ProspectsPage).
 * Pass activeTab='earnings'|'vol' to control which content shows.
 */

import EarningsTab    from './EarningsTab';
import VolAnalysisTab from './VolAnalysisTab';

export default function EarningsDashboard({ t, defaultTab = 'earnings' }) {
  return (
    <div>
      {defaultTab === 'earnings' && <EarningsTab    t={t} />}
      {defaultTab === 'vol'      && <VolAnalysisTab t={t} />}
    </div>
  );
}
